import type { PlayerEvents } from '../player_events.js';
import type { PlayerStore } from '../state/player_store.js';
import type { FeatureInstances, FeaturesDefinition } from './types.js';

export const createFeatures = async <PlaylistItemMeta>(
  store: PlayerStore<PlaylistItemMeta>,
  playerEvents: PlayerEvents,
  features: FeaturesDefinition<PlaylistItemMeta>,
) => {
  const result: FeatureInstances<PlaylistItemMeta> = {};

  if (features.hotkeys) {
    const { HotkeysFeature } = await import('./hotkeys/hotkeys_feature.js');
    const hotkeysFeature = new HotkeysFeature(store, playerEvents);
    hotkeysFeature.init(features.hotkeys);
    result.hotkeys = hotkeysFeature;
  }

  return result;
};
